import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const isKk = (i18n.language || 'kk').startsWith('kk');

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-950 text-foreground-100 overflow-hidden">
      <div className="absolute inset-0 tactical-grid opacity-20 pointer-events-none" />

      <h1 className="absolute text-9xl md:text-[14rem] font-heading font-black text-background-900 select-none pointer-events-none z-0">
        404
      </h1>

      <div className="relative z-10 max-w-md">
        <div className="w-12 h-12 mx-auto flex items-center justify-center border border-accent-500/30 text-accent-500 mb-4">
          <i className="ri-error-warning-line text-2xl" />
        </div>
        <h1 className="text-2xl md:text-3xl font-heading uppercase tracking-widest text-foreground-50">
          {isKk ? 'Бет табылмады' : 'Страница не найдена'}
        </h1>
        <p className="mt-2 text-xs font-mono text-foreground-600 tracking-wider">
          PATH: {location.pathname}
        </p>
        <p className="mt-4 text-sm text-foreground-400 font-label">
          {isKk
            ? 'Сіз іздеген бет жойылған немесе мекенжайы қате енгізілген.'
            : 'Запрашиваемая страница не существует или была перемещена.'}
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-950 text-xs font-label uppercase tracking-widest rounded transition-colors"
          >
            <i className="ri-home-4-line" />
            <span>{isKk ? 'Басты бетке оралу' : 'На главную'}</span>
          </Link>
        </div>
      </div>
    </div>
  );
}